import {
  Briefcase,
  Building,
  CashCoin,
  ClipboardCheck,
  HouseDoor,
  Headset,
  ShieldCheck,
} from "react-bootstrap-icons";

const faqGroups = [
  {
    id: "about",
    title: "About Oasis",
    description: "Who we are, where we operate and what sets us apart.",
    icon: Building,
    categories: ["About Oasis", "Why Oasis"],
  },
  {
    id: "request",
    title: "Requesting & booking",
    description:
      "How to request housing, hold an option and confirm a booking.",
    icon: ClipboardCheck,
    categories: [
      "Housing request",
      "Availability and booking",
      "New enquiries",
    ],
  },
  {
    id: "accommodation",
    title: "Accommodation",
    description: "What is included, pets, parking, accessibility and more.",
    icon: HouseDoor,
    categories: ["Accommodation", "General"],
  },
  {
    id: "rates",
    title: "Rates, payments & changes",
    description:
      "What a rate covers, how to pay, and extending or cancelling a stay.",
    icon: CashCoin,
    categories: ["Rates and payments", "Changes and extensions"],
  },
  {
    id: "stay",
    title: "During your stay",
    description:
      "Arrival, support, maintenance and what to do if something goes wrong.",
    icon: Headset,
    categories: ["Guest journey", "Guest support", "Service issues"],
  },
  {
    id: "quality",
    title: "Quality, safety & privacy",
    description: "How we check properties and protect your information.",
    icon: ShieldCheck,
    categories: ["Quality and safety", "Privacy and security"],
  },
  {
    id: "corporate",
    title: "Corporate programs & technology",
    description:
      "Global housing programs, the Metis platform and sustainability.",
    icon: Briefcase,
    categories: ["Corporate programs", "Technology", "Sustainability"],
  },
];

export default faqGroups;
